var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.275,
    y: 0.275,
    width: 21.45,
    height: 21.45,
    rx: 10.725,
    stroke: "#43419E",
    strokeWidth: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#55e3rpjkwa)",
    fill: "#43419E"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2sutlozp0b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.81 7.05H9.186c-.68.002-1.231.553-1.232 1.232v4.474a.434.434 0 0 0 .868 0V9.092a.241.241 0 0 1 .482 0v8.768a.727.727 0 0 0 1.453 0v-5.007a.241.241 0 0 1 .482 0v5.007a.727.727 0 0 0 1.453 0V9.092a.241.241 0 0 1 .482 0v3.664a.434.434 0 1 0 .868 0V8.283c-.001-.68-.55-1.23-1.23-1.232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.966 18.698a.836.836 0 0 1-.835-.835v-5.008a.133.133 0 1 0-.266 0v5.008a.835.835 0 0 1-1.67 0V9.095a.133.133 0 1 0-.265 0v3.664a.542.542 0 1 1-1.084 0V8.285c0-.74.6-1.339 1.34-1.34h3.625c.74.001 1.34.6 1.34 1.34v4.474a.542.542 0 1 1-1.084 0V9.095a.132.132 0 1 0-.265 0v8.768a.836.836 0 0 1-.836.835zm-.968-6.192a.35.35 0 0 1 .35.35v5.007a.618.618 0 0 0 1.236 0V9.095a.35.35 0 0 1 .699 0v3.664a.325.325 0 1 0 .65 0V8.285c0-.62-.502-1.122-1.123-1.123H9.185c-.62.001-1.122.503-1.123 1.123v4.474a.325.325 0 1 0 .65 0V9.095a.35.35 0 0 1 .7 0v8.768a.618.618 0 0 0 1.236 0v-5.008a.35.35 0 0 1 .35-.35zM10.998 6.232a1.413 1.413 0 1 0 0-2.826 1.413 1.413 0 0 0 0 2.826z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.998 6.34a1.522 1.522 0 1 1 0-3.043 1.522 1.522 0 0 1 0 3.043zm0-2.826a1.305 1.305 0 1 0 0 2.609 1.305 1.305 0 0 0 0-2.61z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.563 14.57a.302.302 0 0 0-.3.301.303.303 0 0 0 .3.3.303.303 0 0 0 .301-.3.303.303 0 0 0-.3-.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "55e3rpjkwa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.3 3.3)",
    d: "M0 0h15.4v15.4H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2sutlozp0b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.3 3.3)",
    d: "M0 0h15.4v15.4H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.3e9c6566.svg";
export { ForwardRef as ReactComponent };